import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericApiService } from './generic-api.service';

export interface AppModel {
  id: string;
  appName: string;
  appVersion: string;
  objectName: string;
  modelUrl: string;
  owner_uid: string;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppModelsService {
  constructor(private api: GenericApiService) {}

  getAppModels(appName?: string, appVersion?: string): Observable<AppModel[]> {
    return this.api.query<AppModel[]>('GET_APP_MODELS', { appName, appVersion });
  }

  linkAppModel(appName: string, appVersion: string, objectName: string, modelUrl: string): Observable<any> {
    return this.api.query<any>('LINK_APP_MODEL', { appName, appVersion, objectName, modelUrl });
  }

  cloneAppModel(id: string, appVersion: string): Observable<any> {
    return this.api.query<any>('CLONE_APP_MODEL', { id, appVersion });
  }

  deleteAppModel(id: string): Observable<any> {
    return this.api.query<any>('DELETE_APP_MODEL', { id });
  }
}
